<template>
  <div class="collage-wrapper">
    <el-row v-for="(row,index) in (colleges)" :key="row[0][0]" v-show="row.length" :class="`row${index}`">
      <el-col :span="4" v-for="college in row" :style="{background: college.color || '#fff',opacity: college.alpha}" :key="college.name">
        <div class="grid-content bg-purple animate__animated animate__fadeIn" v-if="college.image">
          <!-- 解决路径引入问题 -->
          <!-- <el-image class="college-logo" fit="contain" :src="require(`@/assets/images/gaoxiaofangtan/${college.image}`)"></el-image> -->
            <el-image class="college-logo "  :src="require(`@/assets/images/gaoxiaofangtan/${college.image}`)"></el-image>
          <div class="schoolName">{{ college.name }}</div>
          <div class="showGaoXiao" @click="goGaoXiaoVideo(college.url,college.ifImg,college.name)">
            <div class="video-icon">
              <img src="../../assets/images/bo.png" alt="">
            </div>
            <!-- <div class="video-text">
              访谈视频
            </div> -->
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
/**
 * 创建一个高校信息
 * @param url 高校视频唯一
 * @param ifImg 是否为图片
 * @param name 高校昵称 唯一
 * @param image 高校logo图片 忽略路径
 * @param color 高校所在区块显示的背景图 hex rgb rgba
 * @param alpha 透明度 rgba 无效
 * @returns {{image, color: string, alpha: string, name}}
 */
let createCollege = function(url, ifImg, name, image, color = "#fff", alpha = "1.0") {
  return {
    url,
    ifImg,
    name,
    image,
    color,
    alpha
  }
}
export default {
  name: "college-scroll",
  data() {
    return {
      gaoXiaoVideoVisible: true,
      gxVideo: null,
      colleges: [
        [
          createCollege("baodingdianli.mp4",false,"保定电力","保定电力_圆形.png","#3778db"),
          createCollege("gx1.mp4",false,"0大学","","#3778db","0.7"),
          createCollege("gx1.mp4",true,"张家口职业技术学院","张家口职业技术学院_圆形.png","#435ecc"),
          createCollege("gx1.mp4",false,"1大学","","#435ecc","0.8"),
          createCollege("gx1.mp4",true,"河北工程技术学院","河北工程技术学院_圆形.png","#4a51d3"),
          createCollege("gx1.mp4",false,"2大学","","#6225db","0.4"),
        ],
        [
          createCollege("gx1.mp4",false,"3大学","","#5453bb"),
          createCollege("shijiazhuangxueyuan.mp4",false,"石家庄学院","石家庄学院_圆形.png","#4063db"),
          createCollege("gx1.mp4",false,"4大学","","#4063db","0.9"),
          createCollege("hebeijingmao.mp4",false,"河北经贸大学","河北经贸大学_圆形.png","#6225db"),
          createCollege("gx1.mp4",false,"5大学","","#3778db"),
          createCollege("shijiazhuangzhiye.mp4",false,"石家庄职业技术学院","石家庄职业技术学院_圆形.png","#8537e4"),
        ],
        [
          createCollege("gx1.mp4",true,"河北软件职业技术学院","河北软件职业技术学院_圆形.png","#6225db",0.9),
          createCollege("gx1.mp4",false,"9大学","","#4a51d3"),
          createCollege("hebeishida.mp4",false,"河北师范大学","河北师范大学_圆形.png","#2e7ae4"),
          createCollege("gx1.mp4",false,"8大学","","#2e7ae4",0.9),
          createCollege("gx1.mp4",true,"燕山大学","燕山大学.png","#1c4fdb"),
          createCollege("gx1.mp4",false,"6大学","","#1c4fdb",0.8)
        ],
        [
          createCollege("gx1.mp4",false,"","","#3778db"),
          createCollege("gx1.mp4",false,"","","#5453bb"),
          createCollege("gx1.mp4",false,"","","#4a51d3"),
          createCollege("gx1.mp4",false,"","","#1c4fdb"),
          createCollege("gx1.mp4",false,"","","#3778db"),
          createCollege("gx1.mp4",false,"","","#1c4fdb",0.7),
        ],
        [
          createCollege("gx1.mp4",false,"","","#3778db"),
          createCollege("gx1.mp4",false,"","","#5453bb"),
          createCollege("gx1.mp4",false,"","","#4a51d3"),
          createCollege("gx1.mp4",false,"","","#1c4fdb"),
          createCollege("gx1.mp4",false,"","","#3778db"),
          createCollege("gx1.mp4",false,"","","#1c4fdb",0.7),
        ]
      ]
    }
  },
  methods:{
    goGaoXiaoVideo(videoUrl,ifImg,name) {
      console.log(videoUrl,ifImg);
      //如果是图片 显示图片弹框
      if(ifImg) {
        this.$emit('getGaoXiaoImg', ifImg, name)
        return
      }
      // 子传父 传递视频地址 和视频弹框的显示状态
      this.$emit('getGaoXiaoOpenData', videoUrl, true)
    },
    closeGaoXiaoVideoDialog() {
      // 子传父 传递视频地址 和视频弹框的显示状态
      this.$emit('getGaoXiaoOpenData',false)
    },
  }

}
</script>


<style scoped lang="less">
.collage-wrapper {
  width: 84%;
  height: 100%;
  background: url("../../assets/images/gaoxiaofangtan/bg.jpg") round !important;
  .college-logo {
    box-sizing: border-box;
    width: 68%;
    height: 68%;
    margin-top: 5%;
    transition: all .5s;
  }
  .college-logo:hover {
    transform: scale(1.125);
  }

}


.collage-wrapper .el-row {
  &:last-child {
    margin-bottom: 0;
  }

  height: 23.5%;
}

.collage-wrapper .el-col {
  height: 100%;
}
.collage-wrapper .el-image.college-logo {
  display: flex;
  justify-content: center;
  margin-top: 5%;
}

.collage-wrapper .row-bg {
  padding: 10px 0;
}

.collage-wrapper .schoolName {
  font-size: 20px;
  color: #fff;
  padding-top: 4%;
}
.collage-wrapper .grid-content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.collage-wrapper .grid-content:hover .showGaoXiao{
    opacity: 1;
    color: #fff;
}

.collage-wrapper .showGaoXiao {
  z-index: 999;
  position: absolute;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  // flex-direction: column;
  width: 100%;  /* 调整为你需要的宽度 */
  height: 100%; /* 调整为你需要的高度 */
  background: rgba(51, 49, 49, 0.5);
  opacity: 0;
  color: #000;
  cursor: pointer;
  transition: all 0.5s ease-in-out;
  .video-icon {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 35%;
      height: 35%;
    }
  }
  .video-text {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/.el-row.row4 {
    width: 100% !important;
    height: 6% !important;
    background: rosybrown  !important;
  }
}
.collage-wrapper .college-left {
  background: rgba(85, 85, 85, .4);
 }
 .collage-wrapper .close-dialog {
  width: 50px;
  height: 50px;
  background: rgba(198, 198, 198);
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  color: #FFF;
  font-size: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.collage-wrapper .close-dialog:hover {
  cursor: pointer;
  background: rgb(145, 140, 140, .5);
  transition: all .3s;
}
.collage-wrapper .zhuanjia-videos {
  width: 100%;
  height: 100%;
  display: block !important;
}
/deep/ .goxiao-dialog {
  background: blue !important;
}
</style>
